import { Component, input, output } from '@angular/core';
import { LucideAngularModule, Edit, Trash2 } from 'lucide-angular';
import { CommonModule } from '@angular/common';
import { Business } from '../../../../services/business/business.types';

@Component({
  selector: 'app-admin-business-card',
  standalone: true,
  imports: [LucideAngularModule, CommonModule],
  templateUrl: './business-card.component.html'
})
export class AdminBusinessCardComponent {
  // Inputs
  business = input.required<Business>();

  // Outputs
  edit = output<Business>();
  delete = output<string>();

  // Icons
  readonly icons = {
    edit: Edit,
    delete: Trash2
  };

  // Helper methods for template
  formatDate(date: string | undefined): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString();
  }
}
